"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "@/components/ui/button";
import { buttonVariants } from "@/components/ui/button-variants";
import { cn } from "@/lib/utils";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Menu, Phone, Leaf } from "lucide-react";
import Image from "next/image";

export function Header() {
  const pathname = usePathname();
  const isHome = pathname === "/";

  const links = [
    { href: "/", label: "Home" },
    { href: "/#services", label: "Service" },
    { href: "/#about", label: "Über uns" },
    { href: "/#contact", label: "Kontakt" },
  ];

  return (
    <header
      className={cn(
        "absolute top-0 z-50 w-full transition-colors duration-300",
        !isHome && "bg-[#1B4332]", // Dark green background for non-home pages
      )}
    >
      <div className="container flex h-16 items-center justify-between px-4 md:px-6 mx-auto">
        <Link
          href="/"
          className="flex items-center gap-2 font-bold text-white text-xl"
        >
          <Image
            src="/img/logo/jugarden_darkmode2.png"
            alt="Ju Garden Logo"
            width={48}
            height={48}
            className="h-12 w-auto"
          />
          <span>Ju Garden</span>
        </Link>
        <nav className="hidden md:flex gap-6 text-sm font-medium text-white/90">
          {links.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="hover:text-lime-300 transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <Link
            href="tel:+4915164337821"
            className={cn(
              buttonVariants({ variant: "outline" }),
              "hidden md:flex gap-2 bg-transparent text-white border-white hover:bg-white hover:text-black",
            )}
          >
            <Phone className="h-4 w-4" />
            <span>Anrufen</span>
          </Link>
          <Sheet>
            <SheetTrigger
              render={
                <Button
                  variant="ghost"
                  size="icon"
                  className="md:hidden text-white hover:bg-white/20"
                >
                  <Menu className="h-6 w-6" />
                  <span className="sr-only">Toggle menu</span>
                </Button>
              }
            />
            <SheetContent side="right">
              <SheetHeader>
                <SheetTitle>
                  <Link
                    href="/"
                    className="flex items-center gap-2 font-bold text-primary text-xl"
                  >
                    <Leaf className="h-6 w-6" />
                    <span>Ju Garden</span>
                  </Link>
                </SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-4 px-4">
                {links.map((link) => (
                  <Link
                    key={link.href}
                    href={link.href}
                    className="text-lg font-medium hover:text-amber-500 transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
                <Link
                  href="tel:+4915164337821"
                  className={cn(buttonVariants({ className: "w-full mt-4" }))}
                >
                  <Phone className="h-4 w-4 mr-2" />
                  Anrufen
                </Link>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
